module.exports = __webpack_public_path__ + "static/media/ProximaNovaA-Bold.97e32f65.woff2";